import React, { Component } from 'react';
import { DashboardLayout } from '../../../layout';
import connect from 'react-redux/es/connect/connect';
import { createSelector } from 'reselect';
import { Link } from 'react-router-dom';
import { confirmAlert } from 'react-confirm-alert';
import { alertSelectors } from '../../../../common/redux/selectors';
import { userActions } from '../../../../common/redux/actions';
import Skeleton from '@material-ui/lab/Skeleton';
import Rating from '@material-ui/lab/Rating';
import { IconButton } from '@material-ui/core';
import { itemService, globalService as gs } from '../../../../common/services';
import moment from 'moment-timezone';
import { orderStatus } from '../../../../helpers';

class UserDashboard extends Component {

    constructor(props) {
        super(props);
        this.state = {
            bookingItems: null,
            loading: false,
        };
    }

    componentDidMount() {
        const { dispatch } = this.props;
        dispatch(userActions.favorite());
        this.setState({loading: true});
        itemService.booking().then(data => {
            if(data.code) {
                let bookingItems = data.items;
                this.setState({bookingItems, loading: false});
            }
        })
        .catch(exception => {
            gs.showErrors(exception, dispatch, alertSelectors);
            this.setState({loading: false});
        });
    }

    markAsFavorite = (item) => {
        const { dispatch } = this.props;
        confirmAlert({
            title: `Please confirm to remove`,
            message: `Are you sure to remove this favorite list`,
            buttons: [
                {
                    label: 'No',
                    onClick: () => dispatch(alertSelectors.error("You have not accepted the request."))
                },
                {
                    label: 'Yes',
                    onClick: () => dispatch(userActions.favorite("DELETE", null, {item_id: item.id}))
                }
            ]
        });
    }


    render() {
        const { bookingItems, loading } = this.state;
        const { favorites } = this.props;
        const favoriteItems = (favorites && favorites.favorites) ? favorites.favorites : null;

        return (<DashboardLayout>
            <section className="dashboard">
                <div className="row">
                    <div className="col-md-12 mb-4">
                        <div className="post-box">
                            <h2 className="mb-0 page-title">Dashboard</h2>
                        </div>
                    </div>
                    <div className="col-md-12 mb-4">
                        <div className="post-box">
                            <h3 className="mb-0 page-subtitle">My Bookings</h3>
                        </div>
                    </div>
                </div>

                <div className="row">
                    <div className="col-md-12">
                        {(loading) ? <>
                            {[1,2].map((item) =>
                                <div className="post-box mb-4" key={`bok-${item}`}>
                                    <Skeleton variant="text" />
                                    <Skeleton variant="text" />
                                    <Skeleton variant="text" />
                                </div>
                            )}
                        </> : <>
                            {bookingItems && bookingItems.slice(0, 4).map(book =>
                                <div className="post-box mb-4" key={`book-${book.id}`}>
                                    <div className="row">
                                        <div className="col-lg-4 col-md-12 col-12">
                                            <div className="media">
                                                <div className="image">
                                                    <img className="mr-4 img-circle" src={book.userCatalogOrdersItems[0] && book.userCatalogOrdersItems[0].user.avatar} alt="pic" width="70" height="70" />
                                                </div>
                                                <div className="media-body">
                                                    <h5><Link to={`/tutor/view/${book.userCatalogOrdersItems[0] && book.userCatalogOrdersItems[0].user.id}`}>{book.userCatalogOrdersItems[0] && book.userCatalogOrdersItems[0].user.name}</Link></h5>
                                                    <div className="rating mb-2">
                                                        <span className="star">
                                                            {(book.userCatalogOrdersItems[0] && book.userCatalogOrdersItems[0].user.rating_avg) &&
                                                                <Rating name="size-medium" value={parseInt(book.userCatalogOrdersItems[0].user.rating_avg)} readOnly />}
                                                        </span>
                                                        <span> ({book.userCatalogOrdersItems[0] && book.userCatalogOrdersItems[0].user.rating_avg}) {book.userCatalogOrdersItems[0] && book.userCatalogOrdersItems[0].user.count_rating} Ratings</span>
                                                    </div>
                                                    <div className="location">
                                                        <i className="fas fa-map-marker-alt"></i> {book.userCatalogOrdersItems[0] && book.userCatalogOrdersItems[0].user && book.userCatalogOrdersItems[0].user.country && book.userCatalogOrdersItems[0].user.country.name}
                                                    </div> 
                                                </div> 
                                            </div>       
                                        </div>
                                        <div className="col-lg-3 col-md-7 col-12">
                                            <div className="inform mt-4">
                                                <div className="d-flex">
                                                    <label>Date:</label>
                                                    <div className="date">  
                                                        {moment(book.userCatalogOrdersItems[0] && book.userCatalogOrdersItems[0].start_time * 1000).format('MM/DD/YYYY')}<br/> {moment(book.userCatalogOrdersItems[0] && book.userCatalogOrdersItems[0].start_time * 1000).format('LT')} - {moment(book.userCatalogOrdersItems[0] && book.userCatalogOrdersItems[0].start_time * 1000).add(60, 'minutes').format('LT')}
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        <div className="col-lg-2 col-md-5 col-12">
                                            <div className="inform mt-4">
                                                <div className="d-flex">
                                                    <label>Cost:</label>
                                                    <div className="date">  
                                                        ${book.total}
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="inform">
                                                <div className="d-flex">
                                                    <label>Duration:</label>
                                                    <div className="date">  
                                                        60 min
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        <div className="col-lg-3 col-md-12 col-12 d-flex flex-xl-row flex-lg-column justify-content-between">
                                            <div className="sub mt-xl-4 mt-lg-0 mt-4">
                                                {/* <button className="btn btn-light">{book.userCatalogOrdersItems[0] && book.userCatalogOrdersItems[0].catalog.title}</button> */}
                                                <span className={`badge badge-${orderStatus.status(book).cls}`}>{orderStatus.status(book).title}</span>
                                            </div>
                                            <div className="view mt-xl-4 mt-lg-0 mt-4">
                                                <Link to={`/user/booking/${book.id}`}>View Details</Link>
                                            </div>
                                        </div>     
                                    </div>
                                </div>
                            )}
                            {(bookingItems && bookingItems.length === 0) && <div className="col-12 py-3 text-left">Booking not found</div>}
                        </>}
                        <div className="view text-right mt-3 mb-4">
                            <Link to="/user/bookings">View All Bookings</Link>
                        </div>
                    </div>
                </div>

                <div className="row">
                    <div className="col-md-12 mb-4">
                        <div className="post-box">
                            <h3 className="mb-0 page-subtitle">Favorite Tutors</h3>
                        </div>
                    </div>
                </div>

                <div className="row">
                    {(favoriteItems === null) ? <>
                        {[1,2,3,4].map((item) =>
                            <div className="col-md-3" key={`loading-${item}`}>
                                <div className="arrival-box">
                                    <div className="image">
                                        <Skeleton variant="circle" width={'100%'} height={200} />
                                    </div>
                                    <div className="caption">
                                        <Skeleton />
                                        <Skeleton />
                                        <Skeleton />
                                        <Skeleton width="80%" />
                                        <Skeleton width="70%" />
                                        <Skeleton width="60%" />
                                    </div>
                                </div>
                            </div>
                        )}
                    </>
                    : <> 
                        {favoriteItems && favoriteItems.slice(0, 4).map(item => 
                            <div className="col-lg-3 col-md-9 mb-4" key={item.id}>
                                <div className="arrival-box">
                                    <div className="image text-center">
                                        <img className="img-circle" src={(item.favorites.avatar === null) ? '/images/dummy-profile.png' : item.favorites.avatar && item.favorites.avatar.thumb} alt={item.favorites && item.favorites.name} />

                                    </div>
                                    <div className="caption">
                                        <h5><Link to={`/tutor/view/${item.favorite_id}`}>{item.favorites && item.favorites.name}</Link></h5>  
                                        <div className="rating text-center d-flex justify-content-center">
                                            <span className="star">
                                                <Rating name="size-medium" defaultValue={parseFloat(item.favorites && item.favorites.avg_rating)} readOnly />
                                            </span>
                                            <span className="rate"> ({item.favorites && item.favorites.avg_rating}) {item.favorites && item.favorites.count_rating} Ratings</span>
                                        </div>
                                        <h6 className="text-primary text-truncate">
                                            {item.favorites.userCatalogs && item.favorites.userCatalogs.map(subject => subject.title).join(', ')}
                                        </h6>
                                        <p className="address">{item.favorites.country_code && item.favorites.country_code.name}</p>
                                        <div className="wishlist justify-content-between d-flex">                                            
                                            <IconButton className="favorite p-0" aria-label="Favorite" onClick={() => this.markAsFavorite(item)}>
                                                {/* <span className="remove">Remove</span> */}
                                                <i className={`fas fa-heart text-primary`}></i>
                                            </IconButton>
                                        </div>    
                                    </div>
                                </div>
                            </div>
                        )}
                        {(favoriteItems && favoriteItems.length === 0) && <div className="col-12 py-3 text-left">Favorite not found</div>}
                    </>}
                    <div className="col-12">
                        <div className="view text-right my-3">
                            <Link to="/user/favorites">View All Favorite Tutors</Link>
                        </div>
                    </div>
                </div>

            </section> 
        </DashboardLayout>);
    }
}

const processSelector = createSelector(
    state => state.process,
    process => process
);

const favoritesSelector = createSelector(
    state => state.favorites,
    favorites => favorites
);

const mapStateToProps = createSelector(
    processSelector,
    favoritesSelector,
    (process, favorites) => ({
        process, favorites
    })
);

export default connect(mapStateToProps)(UserDashboard);